import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import Header from "components/ui/Header";
import LandingPage from "pages/LandingPage";
import Markets from "pages/Markets";
import MarketDetail from "pages/MarketDetail";
import MarketCreation from "pages/market-creation";
import LoginRegister from "pages/login-register";
import PredictionDashboard from "pages/trading-dashboard";
import PortfolioManagement from "pages/portfolio-management";
import OrderManagement from "pages/order-management";
import WalletTransactions from "pages/wallet-transactions";
import AccountSettings from "pages/account-settings";
import NotFound from "pages/NotFound";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <ScrollToTop />
        <Header />
        <RouterRoutes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/markets" element={<Markets />} />
          <Route path="/market/:marketId" element={<MarketDetail />} />
          <Route path="/market-creation" element={<MarketCreation />} />
          <Route path="/login-register" element={<LoginRegister />} />
          <Route path="/prediction-dashboard" element={<PredictionDashboard />} />
          <Route path="/trading-dashboard" element={<PredictionDashboard />} />
          <Route path="/portfolio-management" element={<PortfolioManagement />} />
          <Route path="/order-management" element={<OrderManagement />} />
          <Route path="/wallet-transactions" element={<WalletTransactions />} />
          <Route path="/account-settings" element={<AccountSettings />} />
          <Route path="*" element={<NotFound />} />
        </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;